import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * 登录
 * @param sessionKey
 */
export const login = (params: {}): AxiosPromise => {
  // eslint-disable-next-line
  return axios.post('/auth/login', params)
}
